import {filterActionTypes} from './filterActionTypes.js';

const categories = [
  {value: 'retail_price', label: 'Retail Price'},
  {value: 'wholesale_price', label: 'Wholesale Price'},
  {value: 'field_price', label: 'Field Price'},
];

const INITIAL_STATE = {
  h_categories: categories,
  h_items_type: null,
  h_items: null,
  h_locations: null,
  h_pricelist: null,
  h_date: null,
  h_Filter: {
    category: 'wholesale_price',
    items_type: '',
    item: '',
    location: '',
    date: '',
  },
};

const filterReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case filterActionTypes.H_LOCATION:
      return {
        ...state,
        h_locations: action.payload,
      };
    case filterActionTypes.H_PRICE_LIST:
      return {
        ...state,
        h_pricelist: action.payload,
      };
    case filterActionTypes.H_ITEMS_TYPE:
      return {
        ...state,
        h_items_type: action.payload,
      };
    case filterActionTypes.H_ITEMS:
      return {
        ...state,
        h_items: action.payload,
      };
    case filterActionTypes.H_DATE:
      return {
        ...state,
        h_date: action.payload,
      };
    case filterActionTypes.H_UPDATE_FILTERS:
      return {
        ...state,
        h_Filter: action.payload,
      };
    default:
      return state;
  }
};

export default filterReducer;
